// Data kota untuk landing page SEO lokal.
// Untuk tambah kota baru, cukup tambah entry di array ini.
// URL akan otomatis: /jasa-website-{slug}

export const cities = [
  {
    slug: "bekasi",
    name: "Bekasi",
    nameFull: "Bekasi & Sekitarnya",
    tagline: "Partner Digital UMKM Bekasi",
    heroTitle: "Jasa Pembuatan Website UMKM Bekasi",
    heroSubtitle:
      "Bantu UMKM Bekasi Selatan, Utara, Barat, Timur go online dengan website Next.js full coding. Base di Bekasi, siap datang untuk survey langsung.",
    intro:
      "Sebagai web developer yang berbasis di Bekasi, saya paham betul karakter pasar dan kebutuhan UMKM lokal — dari warteg di Bekasi Selatan sampai konveksi di Bekasi Utara. Setiap website dibangun dengan SEO lokal supaya muncul saat calon pelanggan cari 'toko [jenis usaha] Bekasi' di Google.",
    localBenefits: [
      "Bisa datang langsung untuk meeting & survey (Bekasi Kota, Cikarang, Tambun)",
      "Paham kompetitor UMKM lokal Bekasi & bantu strategi pembeda",
      "Response WhatsApp cepat karena zona waktu & aktivitas sama",
      "Diskon khusus 10% untuk UMKM ber-KTP Bekasi",
    ],
    caseHighlight: {
      title: "Toko Sepatu di Bekasi Timur naik 3x traffic",
      desc: "Website baru dengan SEO lokal Bekasi + integrasi WA membantu naik dari 200 → 650 pengunjung/bulan dalam 3 bulan.",
    },
    keywords:
      "jasa pembuatan website Bekasi, web developer Bekasi, jasa website UMKM Bekasi, jasa bikin toko online Bekasi",
    seoTitle:
      "Jasa Pembuatan Website UMKM Bekasi 2026 | Mulai Rp 1,5jt | Agung Darmawan",
    seoDescription:
      "Jasa pembuatan website UMKM Bekasi mulai Rp 1,5jt. Website Next.js full coding, SEO-ready, mobile-first. Bisa datang langsung untuk meeting. Diskon 10% untuk UMKM Bekasi.",
  },
  {
    slug: "depok",
    name: "Depok",
    nameFull: "Depok Raya",
    tagline: "Solusi Website UMKM Depok",
    heroTitle: "Jasa Pembuatan Website UMKM Depok",
    heroSubtitle:
      "Bantu UMKM Depok, Sawangan, Cimanggis, hingga Cinere punya website profesional yang mudah muncul di Google Maps Depok.",
    intro:
      "Depok punya banyak potensi UMKM — kuliner mahasiswa UI, fashion muslim, jasa laundry, sampai konveksi Beji. Website yang saya bangun ditargetkan supaya UMKM Depok bisa dilihat calon pelanggan lokal via Google Search & Google Maps.",
    localBenefits: [
      "Melayani seluruh Depok & sekitarnya (jangkauan meeting 40km)",
      "SEO Lokal: muncul saat orang cari '[jenis usaha] Depok'",
      "Integrasi WA Business khusus UMKM di area kampus",
      "Bantu klaim Google Business Profile lokasi Depok",
    ],
    caseHighlight: {
      title: "Laundry Kiloan Depok naik 250% orderan",
      desc: "Website + Google Business Profile terintegrasi bantu laundry lokal Depok naik dari 30 → 105 orderan/minggu.",
    },
    keywords:
      "jasa pembuatan website Depok, web developer Depok, jasa website UMKM Depok, bikin website Depok murah",
    seoTitle:
      "Jasa Pembuatan Website UMKM Depok 2026 | Mulai Rp 1,5jt | Agung Darmawan",
    seoDescription:
      "Jasa pembuatan website UMKM Depok mulai Rp 1,5jt. Website full coding + SEO Lokal Depok. Muncul di Google Maps Depok dalam 30 hari. Konsultasi gratis via WhatsApp.",
  },
  {
    slug: "jakarta",
    name: "Jakarta",
    nameFull: "Jakarta & Jabodetabek",
    tagline: "Web Developer Independen untuk UMKM Jakarta",
    heroTitle: "Jasa Pembuatan Website UMKM Jakarta",
    heroSubtitle:
      "Kualitas agensi Jakarta dengan harga developer independen. Bantu UMKM Jakarta Timur, Selatan, Barat, Utara, Pusat naik ke level digital.",
    intro:
      "Jakarta adalah pasar paling kompetitif untuk UMKM. Website harus premium tapi harga tidak bisa asal — di sinilah developer independen seperti saya bantu UMKM Jakarta dapat kualitas setara agensi Rp 20jt+ dengan harga mulai Rp 1,5jt.",
    localBenefits: [
      "Melayani seluruh Jakarta & Jabodetabek (bisa meeting online / offline)",
      "SEO Lokal ter-optimasi per kecamatan (Kemang, Kelapa Gading, dst)",
      "Portfolio dengan UMKM Jakarta yang bisa dicek langsung",
      "Response cepat, tidak birokrasi seperti agensi besar",
    ],
    caseHighlight: {
      title: "Butik Fashion Jakarta Selatan launching 5 hari",
      desc: "Dari brief sampai launching Next.js e-commerce dengan Midtrans dalam 5 hari kerja — tidak perlu antri di agensi 2-3 bulan.",
    },
    keywords:
      "jasa pembuatan website Jakarta, web developer Jakarta murah, jasa website UMKM Jakarta, bikin website Jakarta bersaing agensi",
    seoTitle:
      "Jasa Pembuatan Website UMKM Jakarta 2026 | Kualitas Agensi Harga Freelance | Agung Darmawan",
    seoDescription:
      "Jasa pembuatan website UMKM Jakarta mulai Rp 1,5jt. Kualitas setara agensi tanpa antre 2 bulan. Next.js full coding, SEO Jakarta, mobile-first. Konsultasi gratis.",
  },
  {
    slug: "tangerang",
    name: "Tangerang",
    nameFull: "Tangerang & Tangsel",
    tagline: "Digital Partner UMKM Tangerang",
    heroTitle: "Jasa Pembuatan Website UMKM Tangerang",
    heroSubtitle:
      "Bantu UMKM Tangerang, BSD, Serpong, Karawaci, Cikupa punya website profesional dengan harga bersaing agensi Serpong.",
    intro:
      "Tangerang punya ekosistem UMKM yang tumbuh cepat — dari kuliner di Karawaci sampai fashion di BSD. Website yang saya bangun ditargetkan bantu UMKM Tangerang tampil profesional dan mudah ditemukan calon pelanggan lokal.",
    localBenefits: [
      "Melayani Tangerang Kota, Tangsel, dan sekitarnya",
      "SEO Lokal per kecamatan Tangerang (BSD, Serpong, Bintaro, dst)",
      "Kualitas setara agensi BSD, harga lebih ramah UMKM",
      "Panduan lengkap Google Business Profile Tangerang",
    ],
    caseHighlight: {
      title: "Warung Kopi Serpong dapat 40 review Google",
      desc: "Kombinasi website SEO + strategi review Google Business Profile bantu warung kopi lokal Serpong ranking #1 Google Maps.",
    },
    keywords:
      "jasa pembuatan website Tangerang, web developer Tangerang, jasa website UMKM BSD, bikin website Tangerang murah",
    seoTitle:
      "Jasa Pembuatan Website UMKM Tangerang & BSD 2026 | Mulai Rp 1,5jt | Agung Darmawan",
    seoDescription:
      "Jasa pembuatan website UMKM Tangerang, BSD, Serpong mulai Rp 1,5jt. Next.js full coding, SEO Lokal Tangerang, mobile-first. Konsultasi gratis via WhatsApp.",
  },
  {
    slug: "bogor",
    name: "Bogor",
    nameFull: "Bogor & Sekitarnya",
    tagline: "Partner Website UMKM Bogor",
    heroTitle: "Jasa Pembuatan Website UMKM Bogor",
    heroSubtitle:
      "Bantu UMKM Bogor Kota, Sentul, Cibinong, Cileungsi punya website profesional yang muncul di pencarian wisata kuliner Bogor.",
    intro:
      "Bogor terkenal dengan wisata kuliner, oleh-oleh, dan penginapan. Website yang saya bangun untuk UMKM Bogor difokuskan ke pencarian long-tail seperti 'oleh-oleh khas Bogor', 'kuliner enak Bogor', 'homestay dekat Puncak' supaya bisnis Anda muncul saat wisatawan mencari.",
    localBenefits: [
      "Melayani Bogor Kota, Kabupaten, dan sekitar Puncak",
      "Fokus SEO wisata & long-tail keyword Bogor",
      "Bantu setup Google Business Profile khusus wisata",
      "Website ramah HP karena mayoritas traffic dari wisatawan mobile",
    ],
    caseHighlight: {
      title: "Homestay Puncak Bogor booking naik 60%",
      desc: "Website mobile-first + SEO lokal 'homestay Puncak' bantu owner homestay Puncak Bogor dapat direct booking tanpa harus bayar komisi OTA.",
    },
    keywords:
      "jasa pembuatan website Bogor, web developer Bogor, jasa website UMKM Bogor, bikin website wisata Bogor",
    seoTitle:
      "Jasa Pembuatan Website UMKM Bogor 2026 | Fokus Wisata & Kuliner | Agung Darmawan",
    seoDescription:
      "Jasa pembuatan website UMKM Bogor mulai Rp 1,5jt. Spesialis website wisata, kuliner, homestay Bogor. SEO Lokal + Google Business Profile. Konsultasi gratis.",
  },
];

export const getCityBySlug = (slug) => cities.find((c) => c.slug === slug);
